import React from 'react';
import { ITextFieldProps, TextField } from '../../../../../../ui';
import { useDetailsFormContext } from '../../hooks/useDetailsFormContext';
import { useTranslation } from '../../../../i18n/translate/useTranslation';

export const City = (props: Partial<ITextFieldProps>) => {
	const { t } = useTranslation();
	const {
		register,
		formState: { errors },
	} = useDetailsFormContext();

	return (
		<TextField
			label={t('parking_details_form_city_label')}
			placeholder={t('parking_details_form_city_placeholder')}
			invalid={!!errors.city}
			error={errors.city?.message}
			{...props}
			{...register('city')}
		/>
	);
};
